(function ($) {
    $.fn.multiselect = function () {

        return this.each(function () {
            var myMultiselect = $(this);
            var cache = {};
            var src = myMultiselect.data('src');
            var parent = '#' + myMultiselect.data('parent');
            var first = myMultiselect.data('first');

            $(myMultiselect).bind('refresh', function (event) {

                var id = $(parent).val();

                if (first) {
                    $(myMultiselect).find('option:gt(0)').remove();
                } else {
                    $(myMultiselect).find('option').remove();
                }

                $.each(cache[id], function (key, value) {
                    $(myMultiselect).append($("<option></option>")
                        .attr("value", key).text(value));
                });

                $(myMultiselect).change();

            });

            $(parent).bind('change', function (event) {

                var id = $(this).val();

                if (id in cache) {
                    $(myMultiselect).trigger('refresh');
                    return;
                }

                $.ajax({
                    type: 'POST',
                    url: src,
                    data: {'q': id},
                    beforeSend: function () {
                        $(myMultiselect).addClass('ui-autocomplete-loading');
                    },
                    complete: function () {
                        $(myMultiselect).removeClass('ui-autocomplete-loading');
                    },
                    success: function (data, status, xhr) {
                        cache[id] = data;
                        $(myMultiselect).trigger('refresh');
                    }
                });
            });

            return myMultiselect;
        });
    };

}(jQuery));
